module.exports = __webpack_public_path__ + "static/attractive-young-man-sleeping-K82XZEM-8284fa19920c589026f62ed7a768d269.jpg";